/**
 * Layout: Contact CTA
 * Slug: contact_cta
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.contact_cta-layout');

	layouts.forEach((layout) => {
		
	});
});
